import axios from 'axios'
import queryString from 'query-string'
import { clearToken, getToken } from '../utils/storage'

const baseUrl = process.env.REACT_APP_BASE_URL

const axiosClient = axios.create({
  baseURL: baseUrl,
  paramsSerializer: (params) => queryString.stringify(params)
})

axiosClient.interceptors.request.use((config) => {
  const token = getToken()
  config.headers = {
    ...config.headers,
    'Content-Type': 'application/json'
  }
  if (token) config.headers.authorization = `Bearer ${token}`
  return config
})

axiosClient.interceptors.response.use(
  (response) => {
    if (response && response.data !== undefined) return response.data
    return response
  },
  (err) => {
    if (!err.response) {
      return Promise.reject({
        status: 0,
        data: { errors: [{ param: 'network', msg: 'Cannot reach the server.' }] }
      })
    }

    if (err.response.status === 401 && getToken()) {
      clearToken()
      window.dispatchEvent(new Event('auth:expired'))
    }

    return Promise.reject(err.response)
  }
)

export default axiosClient
